import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class GetProfilPicUseCase extends BaseUseCase {
    constructor(getProfilePicRep) {
        super();
        this.getProfilePicRep = getProfilePicRep;
    }
    async fetchResult(req) {
        return await this.getProfilePicRep.getProfilePicData(req);
    }
}
export default GetProfilPicUseCase;
